import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\EmailController::verify
 * @see app/Http/Controllers/EmailController.php:95
 * @route '/account/email/update/verify'
 */
export const verify = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verify.url(options),
    method: 'post',
})

verify.definition = {
    methods: ["post"],
    url: '/account/email/update/verify',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\EmailController::verify
 * @see app/Http/Controllers/EmailController.php:95
 * @route '/account/email/update/verify'
 */
verify.url = (options?: RouteQueryOptions) => {
    return verify.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\EmailController::verify
 * @see app/Http/Controllers/EmailController.php:95
 * @route '/account/email/update/verify'
 */
verify.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verify.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\EmailController::verify
 * @see app/Http/Controllers/EmailController.php:95
 * @route '/account/email/update/verify'
 */
    const verifyForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: verify.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\EmailController::verify
 * @see app/Http/Controllers/EmailController.php:95
 * @route '/account/email/update/verify'
 */
        verifyForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: verify.url(options),
            method: 'post',
        })
    
    verify.form = verifyForm
const update = {
    verify: Object.assign(verify, verify),
}

export default update